import { PageResponse } from '..';
import { Customer } from './customer';
import { User } from './user';

export class UserGroup {
    id: string;
    name: string;
    customer?: Customer;
    creationDate?: Date;
    modifyDate?: Date;
    users?: User[];
    userCount?: number;
}


export class UserGroupResponse extends PageResponse {
    content: UserGroup[];
}
